import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router'

import SettingsLayout from '@/layouts/SettingsLayout/SettingsLayout'
import { type Icon } from '@tabler/icons-react'
import useOrganizationSettingsLinks from '@/layouts/SettingsLayout/hooks/useOrganizationSettingsLinks'

export const Route = createFileRoute('/$workspaceName/$environment/organization-settings')({
  component: OrganizationSettingsLayoutRoute,
})

export type SettingsLink = {
  label: string
  href: string
  icon: Icon
  active?: boolean
}

function OrganizationSettingsLayoutRoute() {
  const location = useLocation()
  const { links } = useOrganizationSettingsLinks({ pathname: location.pathname })

  return (
    <SettingsLayout key={location.pathname} title={'Organization Settings'} links={links}>
      <Outlet />
    </SettingsLayout>
  )
}
